export const withCDN = (url: string): string => {
  return `${process.env.NEXT_PUBLIC_CDN || ''}${url}`;
};

// Mirrors images.path in next.config.js; the loader format is Cloudinary's fetch URL.
const IMAGE_FETCH_PATH = 'https://cdn-media.millions.co/image/fetch/';

export const withImageFetch = (url: string, width: number): string =>
  `${IMAGE_FETCH_PATH}f_auto,c_limit,w_${width},q_auto/${url}`;

const isAbsoluteUrl = (url: string): boolean => /^https?:\/\//.test(url);

/** Only absolute URLs can go through the fetch proxy; local assets are returned as-is. */
export const withImageFetchIfRemote = (url: string, width: number): string =>
  isAbsoluteUrl(url) ? withImageFetch(url, width) : url;

/** Only absolute URLs can go through the fetch proxy; local assets have no variants. */
export const buildImageFetchSrcSet = (
  url: string,
  widths: number[]
): string | undefined =>
  widths.length && isAbsoluteUrl(url)
    ? widths
        .map((width) => `${withImageFetch(url, width)} ${width}w`)
        .join(', ')
    : undefined;
